module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"lot":"Lot de {x}","sponsored":"Sponsorisé"},"en":{"lot":"Set of {x}","sponsored":"Sponsored"},"de":{"lot":"Set aus {x}","sponsored":"Gesponsert"},"es":{"lot":"Lote de {x}","sponsored":"Patrocinado"},"it":{"lot":"Lotto di {x}","sponsored":"Sponsorizzato"},"nl":{"lot":"Set van {x}","sponsored":"Gesponsord"},"pt":{"lot":"Lote de {x}","sponsored":"Patrocinados"}}')
  delete Component.options._Ctor
}
